export type ValidationFunction = ((value: string) => boolean )

export const isRequired: ValidationFunction = (value: string) => {
  return value.trim() !== "";
}

export const isEmail: ValidationFunction = (value: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
}

export const isPhone: ValidationFunction = (value: string) => {
  const phoneRegex = /^\d{10}$/; // Adjust the regex according to your phone number format
  return phoneRegex.test(value);
}

export const isValidMessage: ValidationFunction = (value: string) => {
  return value.trim().length > 0;
}